<template>
  <div class="container f-bg-height-col-7">
    <v-stepper v-model="step" alt-labels>
      <div class="row u-justify-content-lg-flex-end">
        <div class="col-12 col-lg-7 u-order-2 u-order-lg-1 full-height-bg">
          <SystemOverview
            :go-back="goBack"
            :open-image="openImage"
            :manual="true"
            :coldroom="$store.getters.coldroom"
            :coldroomsystem="$store.getters.coldroomSystem"
            :cutoutwidth="$store.getters.cutOutWidth"
            :cutoutheight="$store.getters.cutOutHeight"
            :suggestedheight="$store.getters.suggestedHeight"
            :color="$store.getters.color"
            :shelving="this.$store.state.shelvingsSwitch"
            >
          </SystemOverview>
        </div>
        <div class="col-12 col-lg-5 u-order-1 u-order-lg-2 configuration-stepper">
          <v-stepper-header>
            <v-stepper-step complete step="1">{{ $t('coldroom.select') }}</v-stepper-step>
            <v-divider class="complete"></v-divider>
            <v-stepper-step complete step="2">{{ $t('system.select') }}</v-stepper-step>
            <v-divider class="complete"></v-divider>
            <v-stepper-step complete step="3">{{ $t('size_design') }}</v-stepper-step>
            <v-divider class="complete"></v-divider>
            <v-stepper-step :complete="step > 4" step="4">{{ $t('configurator.label') }}</v-stepper-step>
            <v-divider :class="step === 5 ? 'complete':''"></v-divider>
            <v-stepper-step step="5">{{ $t('configurator.results.your_result') }}</v-stepper-step>
          </v-stepper-header>
        </div>
        <div class="col-12 col-lg-5 u-order-3">
          <v-stepper-items>
            <v-stepper-content step="1"></v-stepper-content>
            <v-stepper-content step="2"></v-stepper-content>
            <v-stepper-content step="3"></v-stepper-content>
            <v-stepper-content step="4">
              <div class="configurator">
                <div class="row" v-if="$store.getters.suggestedHeight > 0">
                  <div class="col-12 col-md-8 col-lg-12">
                    <h2>{{ $t('configurator.select_your_individual_config') }}</h2>
                  </div>
                  <div class="col-12 col-md-6 col-lg-8">
                    <div class="u-font-weight-700">
                      <div>{{ $t('configurator.add_system') }}</div>
                    </div>
                    <label class="onex-form label-select">{{ $t('configurator.select_serie') }}</label>
                    <v-select
                      v-model="article"
                      :items="items"
                      :label="$t('configurator.series')"
                      class="onex-form select manual"
                    ></v-select>
                  </div>
                  <div class="col-12 col-md-8 col-lg-12">
                    <div class="configurator__label mt-0 pb-4">{{ $t('configurator.results.chosen_systems') }}</div>
                    <table v-if="isMobile" class="chosen-results">
                      <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in $store.getters.chosenItems" v-bind:key="index">
                          <td>
                            <span class="u-display-block"><small>{{ item['Article number'] }}</small></span>
                            <span class="u-display-block">{{ item.Description }}</span>
                          </td>
                          <td>
                            <div class="amount">
                              <div @click="subtractItem(item.Description)"><i class="icon-minus"></i></div>
                              <span :class="item.amount === 0 ? 'zero': ''">{{ item.amount}}</span>
                              <div @click="addItem(item.Description)"><i class="icon-plus"></i></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table v-else class="chosen-results">
                      <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in $store.getters.chosenItems" v-bind:key="index">
                          <td>{{ item.Description }}</td>
                          <td>{{ item['Article number'] }}</td>
                          <td>
                            <div class="amount">
                              <div @click="subtractItem(item.Description)"><i class="icon-minus"></i></div>
                              <span :class="item.amount === 0 ? 'zero': ''">{{ item.amount}}</span>
                              <div @click="addItem(item.Description)"><i class="icon-plus"></i></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                  <table class="system_resume">

                    <tr>
                      <td>{{ $t('configurator.results.installation_width') }}:</td>
                      <th>{{totalSystem }}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('configurator.results.installation_height') }}:</td>
                      <th>{{heightOfSystem}}</th>
                    </tr>

                  </table>



                      <div v-if="noChosenSystems">
                          <div class="configurator__label u-font-weight-700">{{ $t('configurator.add_accessories') }}</div>
                          <p class="u-color--darkgrey pt-2">{{ $t('configurator.select_first_system') }}</p>
                      </div>
                      <div v-else>
                          <Accessoires
                            :systems="$store.getters.chosenItems" :change-acessory="changeAcessory" :key="accessoiresKey"
                          ></Accessoires>
                        <div class="actions">
                          <div class="btn btn--primary"
                            @click="() => {step=5; setLocalComputedAccessoires(); trackVirtualPageview(); }">
                            {{ $t('common.continue') }}
                          </div>
                        </div>
                      </div>
                    <!--<v-row
                    <v-row
                      v-if="
                        ['view', 'tview'].includes($store.getters.coldroomSystem)
                      "
                    >
                      <v-col>
                        <v-switch
                          v-model="kitFlanges"
                          :label="$t('configurator.kit_flanges')"
                        ></v-switch>
                      </v-col>
                    </v-row>-->
                  </div>
                  <v-dialog
                    v-model="showTFortyFiveOneWarning"
                    width="500"
                  >
                    <v-card>
                      <v-card-title >
                        {{ $t('common.attetion') }}
                      </v-card-title>
                      <v-card-text>
                        {{ $t('configurator.fortyfive_one_warning') }}
                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          @click="disableTFortyFiveOneWarning()"
                        >
                          {{ $t('common.ok') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-dialog
                    v-model="showTFortyFiveTwoWarning"
                    width="500"
                  >
                    <v-card>
                      <v-card-title >
                        {{ $t('configurator.fortyfive_two_title') }}
                      </v-card-title>
                      <v-card-text v-html="$t('configurator.fortyfive_two_warning')"></v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          @click="disableTFortyFiveTwoWarning()"
                        >
                          {{ $t('common.ok') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
                <div class="row" v-else>
                  <div class="no-results">
                    <h2>{{ $t('configurator.results.your_result') }}</h2>
                    <div class="results__label u-font-weight-700 u-text-transform-uppercase">{{ $t('configurator.results.base_on_selection') }}</div>
                    <span class="u-display-block">{{ $t('configurator.results.empty_results')}}</span>
                    <button @click="goBack" class="btn btn--primary">
                      {{ $t('configurator.results.select_new_size_design')}}
                    </button>
                  </div>
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-content step="5">
              <div class="results" v-if="$store.getters.suggestedHeight > 0">
                <div>
                  <h2>{{ $t('configurator.results.your_result') }}</h2>
                  <div class="results__label u-font-weight-700 u-text-transform-uppercase">{{ $t('configurator.results.base_on_selection') }}</div>
                  <table class="system_resume">
                    <tr>
                      <td>{{ $t('coldroom.label') }}:</td>
                      <th>{{ systemType }}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('system.label') }}:</td>
                      <th>{{ $t('system.' + systemName + '.label')}}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('configurator.results.installation_width') }}:</td>
                      <th>{{totalSystem }}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('configurator.results.installation_height') }}:</td>
                      <th>{{heightOfSystem}}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('configurator.colors.label') }}:</td>
                      <th>{{ $store.getters.color }}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('configurator.shelvings.label') }}:</td>
                      <th>{{ this.$store.state.shelvingsSwitch ? 'Yes' : 'No' }}</th>
                    </tr>
                    <tr>
                      <td>{{ $t('configurator.results.doors_number') }}:</td>
                      <th>{{ this.$store.state.numberOfDoors }}</th>
                    </tr>
                    <tr>
                        <td>{{ $t('configurator.results.systems_number') }}:</td>
                        <th>{{numberOfSystems}}</th>
                      </tr>
                  </table>
                </div>

                <div>
                  <div class="u-justify-content-space-between u-align-items-center">
                    <div class="u-display-flex u-align-items-center u-justify-content-space-between">
                      <div class="configurator__label pt-0 pb-4">{{ $t('configurator.results.chosen_systems') }}</div>
                      <button @click="() => { step=4; this.trackVirtualPageview(); }" class="btn btn--ghost-primary icon icon--right u-margin-top-0">
                        {{ label }} <i class="icon-edit"></i>
                      </button>
                    </div>
                  </div>
                  <div v-if="!noChosenSystems">
                    <table v-if="isMobile" class="chosen-results">
                      <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in $store.getters.chosenItems" v-bind:key="index">
                          <td>
                            <span class="u-display-block"><small>{{ item['Article number'] }}</small></span>
                            <span class="u-display-block">{{ item.Description }}</span>
                          </td>
                          <td>{{ item.amount}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table v-else class="chosen-results">
                      <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in $store.getters.chosenItems.filter((acc) => acc.amount > 0)" v-bind:key="index">
                          <td>{{ item.Description }}</td>
                          <td>{{ item['Article number'] }}</td>
                          <td>{{ item.amount}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div v-if="localComputedAccessoires && localComputedAccessoires.accessoires">
                  <div class="u-justify-content-space-between u-align-items-center">
                    <div class="u-display-flex u-align-items-center u-justify-content-space-between">
                      <div class="configurator__label pt-0 pb-4">{{ $t('configurator.results.chosen_accessories') }}</div>
                      <button @click="() => { step=4; this.trackVirtualPageview(); }" class="btn btn--ghost-primary icon icon--right u-margin-top-0">
                        {{ label }} <i class="icon-edit"></i>
                      </button>
                    </div>
                  </div>
                  <div v-if="$store.getters.suggestedHeight > 0">
                    <div v-if="isMobile">
                      <table v-if="localComputedAccessoires.accessoires.filter((acc) => acc.amount > 0)" class="chosen-results first-filter">
                        <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                        </thead>
                        <tbody>
                        <tr v-for="(accessory, index) in localComputedAccessoires.accessoires.filter((acc) => acc.amount > 0).concat(localComputedAccessoires.posts.filter((post) => post.amount > 0))" v-bind:key="index">
                          <td>
                            <span class="u-display-block"><small>{{ accessory.SAP_Code }}</small></span>
                            <span class="u-display-block">{{ accessory.name }}</span>
                          </td>
                          <td>{{ accessory.amount}}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table v-if="!($store.getters.shelvingsSwitch) && localComputedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0))" class="chosen-results second-filter">
                        <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                        </thead>
                        <tbody>
                        <tr v-for="(accessory, index) in localComputedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0))" v-bind:key="index">
                          <td>
                            <span class="u-display-block"><small>{{ accessory.SAP_Code }}</small></span>
                            <span class="u-display-block">{{ accessory.name }}</span>
                          </td>
                          <td>{{ accessory.amount}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <table v-if="$store.getters.shelvingsSwitch && localComputedAccessoires.accessoires.filter((acc) => acc.amount > 0)" class="chosen-results first-filter">
                        <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                        </thead>
                        <tbody>
                        <tr v-for="(accessory, index) in localComputedAccessoires.accessoires.filter((acc) => acc.amount > 0).concat(localComputedAccessoires.posts.filter((post) => post.amount > 0))" v-bind:key="index">
                          <td>{{ accessory.SAP_Code }}</td>
                          <td>{{ accessory.name }}</td>
                          <td>{{ accessory.amount}}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table v-if="!($store.getters.shelvingsSwitch) && localComputedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0))" class="chosen-results second-filter">
                        <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                        </thead>
                        <tbody>
                        <tr v-for="(accessory, index) in localComputedAccessoires.posts.filter((post) => ((post.type == 'adjoiners')||(post.type == 'flange'))&&(post.amount > 0))" v-bind:key="index">
                          <td>{{ accessory.SAP_Code }}</td>
                          <td>{{ accessory.name }}</td>
                          <td>{{ accessory.amount}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div v-if="['view', 'tview'].includes($store.getters.coldroomSystem) && localComputedAccessoires.lighting.filter((light) => light.amount > 0)">
                      <div class="configurator__label">{{ $t('configurator.results.lights_number') }}</div>
                      <table v-if="isMobile" class="chosen-results third-filter">
                        <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name_and_article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                        </thead>
                        <tbody>
                        <tr v-for="(accessory, index) in localComputedAccessoires.lighting.filter((light) => light.amount > 0)" v-bind:key="index">
                          <td>
                            <span class="u-display-block"><small>{{ accessory.SAP_Code }}</small></span>
                            <span class="u-display-block">{{ accessory.name }}</span>
                          </td>
                          <td>{{ accessory.amount}}</td>
                        </tr>
                        </tbody>
                      </table>
                      <table v-else class="chosen-results third-filter">
                        <thead>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.name') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.article') }}</th>
                        <th class="results__label u-font-weight-600 u-text-transform-uppercase">{{ $t('system.amount') }}</th>
                        </thead>
                        <tbody>
                        <tr v-for="(accessory, index) in localComputedAccessoires.lighting.filter((light) => light.amount > 0)" v-bind:key="index">
                          <td>{{ accessory.name }}</td>
                          <td>{{ accessory.SAP_Code }}</td>
                          <td>{{ accessory.amount}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <RequestQuotation
                  :systems="$store.getters.chosenItems"
                  :accessoires="localComputedAccessoires"
                ></RequestQuotation>
              </div>
              <div v-else>
                <div class="no-results">
                  <h2>{{ $t('configurator.results.your_result') }}</h2>
                  <div class="results__label u-font-weight-700 u-text-transform-uppercase">{{ $t('configurator.results.base_on_selection') }}</div>
                  <span class="u-display-block">{{ $t('configurator.results.empty_results') }}</span>
                  <button @click="goBack" class="btn btn--primary">
                    {{ $t('configurator.results.select_new_size_design') }}
                  </button>
                </div>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </div>
      </div>
    </v-stepper>
  </div>
</template>

<style lang="scss">
@import './../sass/main.scss';
.configuration-stepper {
  @include media-breakpoint-up(lg) {
    position: absolute;
    height: rem(100);
  }
}
.actions {
  @include gutter(margin-top, md);
}
table.chosen-results {
  min-width: 100%;
  th,
  td {
    @extend .u-color--black;
    &:first-child {
      @include media-breakpoint-down(md) {
        width: 60%;
      }
      @include media-breakpoint-up(md) {
        width: 45%;
      }
    }
    &:last-child {
      text-align: right !important;
      padding-right: 0 !important;
    }
  }
  th {
    padding: rem(6) rem(12);
    border-bottom: rem(2) solid $color-s400;
  }
  td {
    padding: rem(12);
    border-bottom: rem(1) solid $color-s200;

    &:last-child {
      padding-right: rem(18);
    }
  }
  th:first-child,
  td:first-child  {
      padding-left: 0;
  }
}
h2 {
  @include media-breakpoint-up(md) {
    @include gutter(margin-top, xl);
  }
}

.u-order-3 {

  @include media-breakpoint-up(lg) {
    padding-top: rem(100);
  }
}

table.system_resume {
  @include gutter(margin-top, xs);
  th {
    @include gutter(padding-left, md);
  }
  th,
  td {
    @extend .u-vertical-align-top;
  }
}
.no-results {
  @include gutter(margin-top, lg);
  @include gutter(margin-bottom, xs);
}

.amount {
  border: 1px solid $color-s300;
  width: rem(96);
  margin-left: auto;
  @extend .u-display-flex;
  @extend .u-justify-content-space-between;
  @extend .u-align-items-center;
  @extend .u-text-align-center;

  i {
    font-size: $font-size-xs;
  }

  div {
    padding: rem(6) rem(12);
  }

  span.zero {
    color: $color-s300;
  }
}
</style>

<script>
import SystemOverview from "./SystemOverview.vue";
import Accessoires from "./Accessoires.vue";
import productData from "@/assets/products_new.json";
import accessoires from "@/assets/accessoires.json";
import RequestQuotation from "./RequestQuotation.vue";
import TrackingHelper from "../helpers/TrackingHelper";

export default {
  name: 'ManualSetup',
  components: {
    SystemOverview,
    Accessoires,
    RequestQuotation,
  },
  data () {
    return {
      step: 4,
      selectedSerie: null,
      isMobile: false,
      changeAcessory: "Change Accessory",
      label: "Edit",
      systemName: this.$store.getters.coldroomSystem,
      expand: false,
      imgSrc: "",
      showTFortyFiveOneWarning: false,
      showTFortyFiveTwoWarning: false,
      accessoiresKey: 0,
      localcomputedAccessoires : {}
    };
  },
  beforeCreate() {
    if (this.$store.getters.suggestedHeight > 0) {
      var r = /\d+/;
      this.$store.commit(
        "setArticle",
        Object.keys(
          productData[this.$store.state.coldroom][
            this.$store.state.coldroomSystem
          ][this.$store.state.color][this.$store.state.suggestedHeight]
        )
          .sort()
          .reverse()
          .sort(
            (a, b) => parseInt(a.match(r)) - parseInt(b.match(r))
          )[0]
      );
    }
  },
  beforeMount() {
    if (this.$store.getters.suggestedHeight > 0) {
      this.$store.commit("setKitFlanges", true);
      this.$store.commit("setShelvesPerDoor", 5);
      this.$store.commit("setShelvesWirePlate", "wire");
      this.$store.commit("setPostsFrontBack", "back");
      this.$store.commit("setGravitySheetSwitch", false);
      if (this.$store.state.coldroomSystem == "classic") {
        //Special case of T45/S45
        if (['45'].includes(this.$store.state.article.slice(-2))) {
          this.$store.commit("setShelvesSingleDouble", "double");
        }
        else {
          this.$store.commit("setShelvesSingleDouble", "single");
        }
      } else {
        this.$store.commit("setShelvesSingleDouble", "double");
      }
      this.$store.commit("setContainerStops", false);
      this.$store.commit("setFrontStopsPerShelf", 6);
      this.$store.commit("setDividersPerShelf", 5);
      this.$store.commit(
        "setChosenItems",
        productData[this.$store.state.coldroom][this.$store.state.coldroomSystem][
          this.$store.state.color
        ][this.$store.state.suggestedHeight][this.$store.state.article]
      );
      if (this.$store.state.coldroomSystem == "classic") {
        this.imgSrc = {
          backgroundImage: "url(./images/inapp/ConfigBGClassic.jpg)",
        };
      } else {
        this.imgSrc = {
          backgroundImage: "url('./images/inapp/ConfigBGTview.jpg')",
        };
      }
    }
  },
  beforeUpdate () {
    this.forceRerender()
  },
  beforeDestroy () {
    if (typeof window === 'undefined')  {
      return window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  methods: {
    trackVirtualPageview () {
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.virtualPageview(`Manual Configurator${this.step === 5?' Results':''}`);
    },
    setLocalComputedAccessoires() {
      this.localComputedAccessoires = JSON.parse( JSON.stringify ( this.$store.getters.computedAccessoires ) )
    },
    forceRerender() {
      this.accessoiresKey += 1;
    },
    disableTFortyFiveOneWarning() {
      this.showTFortyFiveOneWarning = false
    },
    disableTFortyFiveTwoWarning() {
      this.showTFortyFiveTwoWarning = false
    },
    addItem(item) {
      const findSystemByName = (element) => element.Description == item;
      this.$set(
        this.$store.state.chosenItems[
          this.$store.state.chosenItems.findIndex(findSystemByName)
        ],
        "amount",
        this.$store.state.chosenItems[
          this.$store.state.chosenItems.findIndex(findSystemByName)
        ].amount + 1
      );
      //Generate Warning if T.View T45-1 is added
      if(
        ['view', 'tview'].includes(this.$store.getters.coldroomSystem) &&
        this.$store.state.shelvingsSwitch && item.includes('T45-1') &&
        this.$store.state.chosenItems[
          this.$store.state.chosenItems.findIndex(findSystemByName)
        ].amount < 2
         ){
        this.showTFortyFiveOneWarning = true
      }
      //Generate Warning if Classic S45-2 and T45-2 is added
      if(
        ['classic'].includes(this.$store.getters.coldroomSystem) &&
        item.includes('45-2') &&
        this.$store.state.chosenItems[
          this.$store.state.chosenItems.findIndex(findSystemByName)
        ].amount < 2
         ){
        this.showTFortyFiveTwoWarning = true
      }
    },
    subtractItem(item) {
      const findSystemByName = (element) => element.Description == item;
      this.$set(
        this.$store.state.chosenItems[
          this.$store.state.chosenItems.findIndex(findSystemByName)
        ],
        "amount",
        Math.max(
          this.$store.state.chosenItems[
            this.$store.state.chosenItems.findIndex(findSystemByName)
          ].amount - 1,
          0
        )
      );
    },
    goBack () {
      this.$router.push({
        name: "First Steps",
        params: {
          step: 3,
          isThirdStep: true,
          systemName: this.systemName
        }
      });
    },
    onResize () {
      this.isMobile = window.innerWidth < 720
    },
    openImage () {
      let routeData = '../../Schott20211206/?front_back=' +
                    this.$store.state.postsFrontBack +
                    '&wired=' +
                    this.convertPlateWireToBooleanString +
                    '&systems=' +
                    this.convertBestSystemToString + '&shelvescount=' + this.$store.state.shelvesPerDoor +
                    '&doubleshelves=' + this.convertSingleDoubleToString +
                    '&sheets=' + this.convertGravitySheetsToString +
                    '&stops=' + this.convertContainerStopsToString +
                    '&shelves=' + this.convertShelvingsSwitchToString
      window.open(routeData, '_blank');
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.clickTracking('button', 'view results in 3d');
    },
    setRouteParams () {
      if (
        this.$route.params != undefined &&
        this.$route.params.step != undefined
      ) {
        this.step = this.$route.params.step;
        this.systemName = this.$route.params.systemName;
        this.selectedSerie = this.$route.params.selectedSerie;
      }
    },
    // get serie selected if info is coming from Best Results (System)
    getSelectedSerie () {
      if (this.selectedSerie) {
        this.$store.state.article = this.selectedSerie;

      }
    }
  },
  computed: {
    items: {
      get () {
        var r = /\d+/;
        const itemsResult = Object.keys(
          productData[this.$store.state.coldroom][
            this.$store.state.coldroomSystem
          ][this.$store.state.color][this.$store.state.suggestedHeight]
        )
          .sort()
          .reverse()
          .sort(
            (a, b) => parseInt(a.match(r)) - parseInt(b.match(r))
          );
        if (itemsResult) {
          return itemsResult;
        } else {
          return null;
        }
      }
    },
    convertBestSystemToString: {
      get() {
        const arrayOfArticles = this.$store.state.chosenItems.map((x) =>
          (x["Article number"] + ",").repeat(x["amount"])
        );
        return arrayOfArticles.join("").slice(0, -1).replaceAll(
            '1855303', '1738368'
          ).replaceAll(
            '1855304', '1738369'
          ).replaceAll(
            '1855305', '1738370'
          ).replaceAll(
            '1855254', '1737617'
          ).replaceAll(
            '1855253', '1737618'
          ).replaceAll(
            '1855255', '1737619'
          ).replaceAll(
            '1855300', '1737623'
          ).replaceAll(
            '1855299', '1737624'
          ).replaceAll(
            '1855301', '1737625'
          ).replaceAll(
            '1855297', '1737620'
          ).replaceAll(
            '1855296', '1737621'
          ).replaceAll(
            '1855298', '1737622'
          ).replaceAll(
            '1847945', '1737581'
          ).replaceAll(
            '1847946', '1737582'
          ).replaceAll(
            '1847947', '1737583'
          ).replaceAll(
            '1847933', '1737591'
          ).replaceAll(
            '1847934', '1737592'
          ).replaceAll(
            '1847935', '1737594'
          ).replaceAll(
            '1847927', '1737584'
          ).replaceAll(
            '1847928', '1737589'
          ).replaceAll(
            '1847929', '1737590'
          );
      },
    },
    convertPlateWireToBooleanString: {
      get() {
        if (this.$store.state.shelvesWirePlate == "plate") {
          return "false";
        } else {
          return "true";
        }
      },
    },
    convertShelvingsSwitchToString: {
      get() {
        if (this.$store.state.shelvingsSwitch){
          return "true"
        }
        else {return "false"}
      }
    },
    convertSingleDoubleToString: {
      get() {
        if (this.$store.state.shelvesSingleDouble == "double") {
          return "true";
        } else {
          return "false";
        }
      },
    },
    convertGravitySheetsToString: {
      get() {
        if (this.$store.state.gravitySheetSwitch) {
          return "true";
        } else {
          return "false";
        }
      },
    },
    convertContainerStopsToString: {
      get() {
        if (this.$store.state.containerStops) {
          return "true";
        } else {
          return "false";
        }
      },
    },
    heightOfSystem: {
      get() {
        let firstKey = Object.keys(
          productData[this.$store.state.coldroom][
            this.$store.state.coldroomSystem
          ][this.$store.state.color][this.$store.state.suggestedHeight][
            this.$store.state.article
          ]
        )[0];
        return productData[this.$store.state.coldroom][
          this.$store.state.coldroomSystem
        ][this.$store.state.color][this.$store.state.suggestedHeight][
          this.$store.state.article
        ][firstKey].Height;
      },
    },
    numberOfSystems: {
      get() {
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue["amount"];
        let numberOfSystems = this.$store.state.chosenItems.reduce(reducer, 0);
        this.$store.commit("setNumberOfSystems", numberOfSystems);
        return numberOfSystems;
      },
    },
    totalSystem: {
      get() {
        const reducer = (accumulator, currentValue) =>
          ['view', 'tview'].includes(this.$store.getters.coldroomSystem)
            ? accumulator + currentValue["amount"] * (currentValue["Width"] - 5)
            : accumulator + currentValue["amount"] * currentValue["Width"];
        let totalSystem = this.$store.state.chosenItems.reduce(reducer, 0);
        // In case of classic, 45 this is already correct
        // For view and tview we have to accomodate kit flanges
        // For classic, not 45 series adjoiners are added
        if (['view', 'tview'].includes(this.$store.getters.coldroomSystem)) {
          totalSystem = totalSystem + 5 + this.$store.state.kitFlanges * 4;
        } else if (this.$store.state.coldroomSystem == "classic") {
          if (this.$store.state.article.slice(-2) != "45") {
            totalSystem = Math.max(
              totalSystem + (this.$store.state.numberOfSystems - 1) * 40,
              0
            );
          }
        }
        this.$store.commit("setTotalSystem", totalSystem);
        return totalSystem;
      },
    },
    article: {
      get() {
        this.$store.commit(
          "setChosenItems",
          productData[this.$store.state.coldroom][
            this.$store.state.coldroomSystem
          ][this.$store.state.color][this.$store.state.suggestedHeight][
            this.$store.state.article
          ]
        );
        this.$store.commit(
          "setComputedAccessoires",
          accessoires[this.$store.state.coldroomSystem][
            this.$store.state.color
          ][this.$store.state.article.slice(-2)]
        );
        return this.$store.state.article;
      },
      set(value) {
        this.$store.commit("setArticle", value);
        if (['45', '90'].includes(value.slice(-2))) {
          this.$store.commit("setShelvesSingleDouble", 'double')
        } else if (this.$store.state.coldroomSystem == 'classic'){
          this.$store.commit("setShelvesSingleDouble", 'single')
        }
      },
    },
    kitFlanges: {
      get() {
        return this.$store.state.kitFlanges;
      },
      set(value) {
        var i = value ? 1 : 0;
        this.$store.commit("setKitFlanges", i);
      },
    },
    noChosenSystems: {
      get() {
       const isZero = (currentValue) => currentValue === 0;
       const amount = this.$store.getters.chosenItems.map(x => (x['amount']));
       return amount.every(isZero);
      },
    },
    systemType: {
      get () {
        if (this.$store.getters.coldroom === "NT") {
          return "Normal Temperature";
        } else {
          return "Low Temperature";
        }
      }
    },
  },
  mounted () {
    this.trackVirtualPageview();
    this.onResize();
    this.setRouteParams();
    this.getSelectedSerie();
  }
};
</script>
